@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.avatar {
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;

  &Image {
    &Fallback {
      align-items: center;
      border: 1px solid map.get(core.$colors, accent);
      border-radius: 4px;
      display: flex;
      height: 28px;
      justify-content: center;
      width: 28px;
    }
  }
}
